export default "__VITE_ASSET__4313a9fd__"